export default "__VITE_ASSET__5ef9519d__"